export enum ShareCatalogTestIds {
  DIALOG = 'share-catalog-dialog',
  ACCESS_CONFIG_SELECT = 'share-catalog-access-config-select',
  ACCESS_CONFIG_OPTION_PUBLIC = 'share-catalog-access-config-public',
  ACCESS_CONFIG_OPTION_PRIVATE = 'share-catalog-access-config-private',
  GENERATE_LINK_BUTTON = 'share-catalog-generate-link-button',
  SHARE_BUTTON = 'share-catalog-share-button',
  CANCEL_BUTTON = 'share-catalog-cancel-button',
  LINK_INPUT = 'share-catalog-link-input',
  COPY_LINK_BUTTON = 'share-catalog-copy-link-button',
}
